<template>
  <div>
    <b-row class="mt-5">
      <b-col md="9">

        <b-form-group label="ویژگی های محصول" class="w-100" label-for="table">
          <b-table id="table" striped hover :fields="fields" :items="items">

            <template #cell(value)="data">

              <b-form-select
                  :options="data.item.feature_attributes"
                  v-model="data.item.value"
                  v-if="data.item.type == 'list'"
              ></b-form-select>

              <b-form-textarea v-model="data.item.value" :readonly="data.item.variation==1" v-else/>

            </template>

            <template #cell(extraValue)="data">

              <div v-if="data.item.variation==1">

                <b-form-group id="input-group-2" label="تعداد">
                  <b-form-input
                      v-model="data.item.quantity"
                      placeholder="تعداد"
                      required
                  ></b-form-input>
                </b-form-group>


                <b-form-group id="input-group-2" label="قیمت">
                  <b-form-input
                      v-model="data.item.price"
                      placeholder="قیمت"
                      required
                  ></b-form-input>
                </b-form-group>


                <b-form-group id="input-group-2" label="تخفیف">
                  <b-form-input
                      v-model="data.item.offer"
                      placeholder="تخفیف"
                      required
                  ></b-form-input>
                </b-form-group>

              </div>

            </template>
            <template #cell(action)="data">
              <span
                  class="h5"
                  @click="deleteFeature(data.item)"
                  v-b-tooltip.hover
                  title="حذف"
              >
                <b-icon icon="trash"></b-icon>
              </span>


              <span class="h5 mt-3" @click="updateFeature(data.item)" title="ثبت" v-b-tooltip.hover
                    v-if="$route.params.slug !== undefined">
                <b-icon icon="check-circle-fill"></b-icon>
              </span>

            </template>
          </b-table>
        </b-form-group>
      </b-col>
      <b-col md="3" class="mt-4">
        <b-form @submit.prevent="searchFeature()">
          <b-form-input
              id="input"
              placeholder=" جستجو"

              v-model="searchedWord"
              class="mb-1"
          ></b-form-input>
        </b-form>

        <div class="feature_box_selector text-right shadow p-2 rounded">
          <p @click="addToFeatureTable(feature.name)" class="w-100 feature_box_selector_item"
             v-for="feature in Features">{{ feature.name }}</p>
        </div>


      </b-col>
    </b-row>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: "FeaturesManager",
  props: ["selectFeature", "itemsTable", "Features"],
  data() {
    return {
      fields: [
        {key: "name", label: "نام ویژگی"},
        {key: "value", label: "مقدار ویژگی"},
        {key: "extraValue", label: ""},
        {key: "action", label: ""},
      ],
      selectedFeature: this.selectFeature,
      items: this.itemsTable,
      features: this.Features,
      searchedWord: ''
    };
  },
  computed: {
    ...mapGetters({
      product: 'Product/getProduct'
    })
  },
  methods: {
    deleteFeature(feature) {
      if (this.$route.params.slug !== undefined) {
        if (feature.tag == 'update') {
          if (confirm('آیا از حذف این ویژگی اطمینان دارید؟')) {
            this.$store.dispatch('Product/deleteProductFeature', feature)
            this.items.splice(this.items.indexOf(feature), 1);
          }
        } else {
          this.items.splice(this.items.indexOf(feature), 1);
        }
      } else {
        this.items.splice(this.items.indexOf(feature), 1);
      }
    },
    async updateFeature(feature) {

      if (feature.tag === 'update') {
        await this.$store.dispatch('Product/updateFeatureOfTheProduct', feature)
      } else {
        const form = {...feature, product_id: this.product.id}
        await this.$store.dispatch('Product/createFeatureProduct', form).then(async () => {
          await this.$emit('create-feature-event', feature)
        })
      }
    },
    addToFeatureTable(selectedFeature) {
      for (let i in this.Features) {
        if (selectedFeature == this.Features[i].name) {

          let value = "";
          let feature_attributes = [];
          console.log(this.Features[i]);
          if (this.Features[i].feature_attributes.length > 0) {
            let temp_value = this.Features[i];
            value = temp_value.type == 'list' ? temp_value.feature_attributes[0].id : temp_value.feature_attributes[0].value;
            this.Features[i].feature_attributes.forEach(item => {
              feature_attributes.push({value: item.id, text: item.value});
            })
          }

          let f = {
            id: this.Features[i].id,
            name: this.Features[i].name,
            feature_attributes: feature_attributes,
            type: this.Features[i].type,
            tag: 'create',
            value: value,
          };
          this.selectedFeature.push(f);
          this.items.push(f);
        }
      }
    },
    searchFeature(){
      if (this.searchedWord != "") {
        const searchWord = {words: this.searchedWord};
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      }
    },
  },
};
</script>
<style scoped>
.feature_box_selector {
  height: 150px;
  width: 100%;
  overflow-x: auto;
}

.feature_box_selector_item {
  cursor: pointer;
}

</style>
